export const formatIgHashtag = (value: string) =>
    '#' + value.replace(/[\s!@#$%^&*()=+./,[{\]};:'"?><]+/g, '').toLowerCase();
export const unformatIgHashtag = (hashtag: string) => hashtag.replace(/#/g, '');
